import React, { FunctionComponent, useState, useEffect } from 'react'
import { Button, Modal } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { useDebouncedCallback } from 'use-debounce'

import { ModalHeader } from 'Stories/ModalHeader/ModalHeader.stories'

import { SkipReviewModalProps } from './SkipReviewModalProps'

import {
  SkipReviewModalWrapper,
  SkipReviewModalHeader,
  SkipReviewModalText,
  SkipReviewModalNote,
  GreenText,
  ModalButtons,
} from './styles'

const ModalComponent: FunctionComponent<SkipReviewModalProps> = ({
  modalIsOpen,
  toggle,
  handleSkipReview,
}) => {
  const { t } = useTranslation()

  const [isSkipDisabled, setIsSkipDisabled] = useState(false)

  const [debounceSkipReview] = useDebouncedCallback(() => {
    setIsSkipDisabled(true)
    handleSkipReview()
  }, 1000)

  useEffect(() => {
    if (modalIsOpen) {
      setIsSkipDisabled(false)
    }
  }, [modalIsOpen])

  return (
    <div>
      <Modal
        fade={false}
        className="modal-dialog--success modal-dialog--header "
        isOpen={modalIsOpen}
        modalClassName="ltr-support"
        toggle={toggle}
      >
        <div className="modal__header">
          <button
            className="lnr lnr-cross modal__close-btn"
            type="button"
            onClick={toggle}
          />
          <ModalHeader content={t('reviewsPage.reviewTrack')} />
        </div>
        <SkipReviewModalWrapper>
          <SkipReviewModalHeader>
            {t('reviewsPage.skipReview')}
          </SkipReviewModalHeader>
          <SkipReviewModalText>
            {t('reviewsPage.ifThisTrack')}
          </SkipReviewModalText>
          {/* <SkipReviewModalNote>
            {t('reviewsPage.note')}&nbsp;
            <GreenText>
              {t('reviewsPage.whenYouAreSkippingReviewYouWillEarnExtraScore')}
            </GreenText>
          </SkipReviewModalNote> */}
          <ModalButtons className="modal__buttons">
            <Button className="btn-outline-success" onClick={toggle}>
              {t('reviewsPage.cancel')}
            </Button>
            <Button
              disabled={isSkipDisabled}
              className="btn-continue"
              color="success"
              onClick={debounceSkipReview}
            >
              {t('reviewsPage.confirm')}
            </Button>
          </ModalButtons>
        </SkipReviewModalWrapper>
      </Modal>
    </div>
  )
}

export default ModalComponent
